import { useState, useRef, useEffect, Fragment } from 'react'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import { Box } from '@material-ui/core'
import { IconButton } from '@mui/material'

export default function SplitButton({ getActions, style = {} }) {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [actionsOption, setActionsOption] = useState([])
  useEffect(() => {
    getActions().then((res) => {
      setActionsOption(res)
    })
  }, [getActions])

  const handleMenuItemClick = (event, index) => {
    event.preventDefault()
    event.stopPropagation()
    setSelectedIndex(index)
    setOpen(false)
    actionsOption[index]?.onClick()
  }

  const handleToggle = (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  return (
    <Box style={{ margin: '0 0 0 auto', ...style }}>
      <Button
        variant="contained"
        ref={anchorRef}
        aria-label="split button"
        size="small"
        onClick={handleToggle}
        endIcon={<ArrowDropDownIcon />}
        sx={{ padding: '4px 8px' }}
      >
        Actions
      </Button>
      <Popper
        sx={{ zIndex: 10 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {actionsOption?.map((actionItem, index) => (
                    <MenuItem
                      key={'key_option' + index}
                      disabled={actionItem.disabled}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {actionItem.option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  )
}
